import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import warning from './images/warning.png';
import error from './images/error.png';
import success from './images/success.png';


const useStyles = makeStyles(() => ({
  image: {
    position: 'absolute',
    bottom: '10px',
    right: '10px',
    height: '100%',
    filter: 'opacity(0.2)'
  }
}));

export default function AlertDialog({children, title, open, onClose, type}) {
  const classes = useStyles();
  const setImageUrl = (type) => {
    if (type === 'warning') {
      return warning;
    }

    if (type === 'error') {
      return error;
    }

    if (type === 'success') {
      return success;
    }


    return null;
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => onClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className={`bg-${type} relative`} style={{backgroundImage: `url(${setImageUrl(type)})`}}>
          <img
            src={setImageUrl(type)}
            alt={type}
            className={classes.image}
          />
          <DialogTitle id="alert-dialog-title" className="relative">
            <span className="text-24">{title}</span>
          </DialogTitle>
          <Divider className="divider-light" />
          <DialogContent className="p-5 relative">
            {children || null}
          </DialogContent>
        </div>
        <DialogActions className="p-5">
          <Button
            onClick={() => onClose(false)}
            variant="contained"
            color="primary" autoFocus
            className="min-w-125"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
